<template>
    <footer class="text-white mt-auto" style="background-color: #161e2d;">
      <div class="max-w-7xl mx-auto py-6 px-4 sm:px-6 lg:px-8">
        <div class="flex flex-col md:flex-row justify-between items-center">
          <!-- Copyright and attribution -->
          <div class="text-center md:text-left mb-4 md:mb-0">
            <p class="text-sm text-gray-300">
              &copy; {{ currentYear }} Investeks -  All rights reserved.
            </p>
          </div>
          
          <!-- App made by section -->
          <div class="flex items-center space-x-2">
            <span class="text-sm text-gray-300">App made by:</span>
            <a 
              href="https://masterbit.eu" 
              target="_blank" 
              rel="noopener noreferrer"
              class="text-sm font-medium text-white hover:text-blue-300 transition-colors duration-200 flex items-center space-x-1"
            >
              <span>Master Bit</span>
              <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14"></path>
              </svg>
            </a>
          </div>
        </div>
      </div>
    </footer>
  </template>
  
  <script>
  export default {
    name: 'AppFooter',
    data() {
      return {
        currentYear: new Date().getFullYear()
      }
    }
  }
  </script>